//
// Copyright 2024 DXOS.org
//

/**
 * Echos the request data.
 */
export default async ({ data }: any) => data;
